export const ALLOWED_MIME_TYPES = [
  'application/pdf',
  'image/jpeg',
  'image/png',
  'image/heic',
  'image/heif',
];

export const ALLOWED_FILE_INPUT_ACCEPT =
  '.pdf,.jpg,.jpeg,.png,.heic,.heif,application/pdf,image/jpeg,image/png,image/heic,image/heif';

export const MAX_BYTES = 30 * 1024 * 1024;

export const CATEGORY_ORDER = [
  'Identification & Personal',
  'Marital',
  'Estate & Property',
  'Beneficiaries',
  'Other',
];

// Document types the testator must download, complete and upload back.
export const DOCUMENT_TEMPLATES = {
  'TestatorDocuments::AssetsAndLiabilitiesList': {
    path: 'pdfs/Asset-and-Liability-Schedule.pdf',
    label: 'Download the Asset & Liability Schedule',
  },
};

export function templateFor(type) {
  const template = DOCUMENT_TEMPLATES[type];
  if (!template) return null;
  return {
    ...template,
    href: `${process.env.BASE_URL || '/'}${template.path}`,
  };
}

export function expiryLabel(months) {
  if (!months) return null;
  return months === 1 ? 'Valid for 1 month' : `Valid for ${months} months`;
}

export function fileIconKey(contentType) {
  if (contentType === 'application/pdf') return 'mdiFilePdfBox';
  if (typeof contentType === 'string' && contentType.startsWith('image/'))
    return 'mdiFileImage';
  return 'mdiFileDocumentOutline';
}

export function isAllowedFile(file) {
  return (
    ALLOWED_MIME_TYPES.includes(file.type) &&
    file.size > 0 &&
    file.size <= MAX_BYTES
  );
}

// Returns: [{ name: 'Identification & Personal', entries: [{ category, documents: [...] }, ...] }, ...]
// `entries` are the placeholder/category rows in display order; each entry includes
// the catalogue metadata plus any documents the testator has uploaded for that type.
export function groupDocumentsByCategory(categories, documents) {
  const docsByType = documents.reduce((acc, d) => {
    acc[d.type] = acc[d.type] || [];
    acc[d.type].push(d);
    return acc;
  }, {});

  const grouped = CATEGORY_ORDER.map(name => ({ name, entries: [] }));
  const byName = grouped.reduce((acc, g) => {
    acc[g.name] = g;
    return acc;
  }, {});

  categories.forEach(cat => {
    const group = byName[cat.category];
    if (!group) return;
    group.entries.push({
      ...cat,
      documents: docsByType[cat.type] || [],
    });
  });

  return grouped.filter(g => g.entries.length > 0);
}
